import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {LoginService} from '../../../login-page/services/login.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const expectedRoles = next.data.expectedRoles;

    const role = this.loginService.role;

    if (expectedRoles.indexOf(role) === -1) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }

  constructor(public router: Router,
              public loginService: LoginService) {}
  
}
